// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-A":"A_outdoor-recreation-A__vuOzu"};